import { render, staticRenderFns } from "./RelativeSectionAdderLine.vue?vue&type=template&id=3ecb382c&"
import script from "./RelativeSectionAdderLine.vue?vue&type=script&lang=js&"
export * from "./RelativeSectionAdderLine.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports